module.exports = __webpack_public_path__ + "static/media/success.b595ce21.mp3";